import { render, staticRenderFns } from "./FeedbackData.vue?vue&type=template&id=fecc8102"
import script from "./FeedbackData.vue?vue&type=script&lang=js"
export * from "./FeedbackData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports